import type { Collection } from 'state/utils/types';
import type { HttpErrorKind } from 'utils/errors/errors';

import type { SecondaryMarketQuotesTabType } from '../../model';

export type SecondaryMarketLoadingStatus = 'loading' | 'loaded' | 'failed' | 'not_yet';

export type BcsProductKey = {
  source: string;
  subType: string | 'ID_FO' | 'ID_WARRANT';
  code: string;
};
export type SecondaryMarketQuotesState = Readonly<{
  tabType: SecondaryMarketQuotesTabType;
  key: string;
  initFormStatus: SecondaryMarketLoadingStatus;
  errorKind?: HttpErrorKind;
  errorMessage?: string;
}>;

export type SecondaryMarketQuotesStateMap = Collection<SecondaryMarketQuotesState>;

export const initialSecondaryMarketQuotesState: SecondaryMarketQuotesStateMap = {};
